export default "__VITE_ASSET__fcea0486__"